export const NIVELES_TROFEOS_CERTAMEN = [
  {
    NOMBRE: 'Isla de los Recuerdos Congelados',
    ICONO: 'cede_1.png',
    ICONO_ACTIVO: 'cede_1_activo.png',
    UUID: '4FA04895-B620-41ED-91E0-B0716AF98C33'
  },
  {
    NOMBRE: 'Isla de la Pereza Mental',
    ICONO: 'cede_2.png',
    ICONO_ACTIVO: 'cede_2_activo.png',
    UUID: 'B39081CC-FD7C-476D-9C9B-26A59C6DFBCE'
  },
  {
    NOMBRE: 'Isla de los Malos Pensamientos',
    ICONO: 'cede_3.png',
    ICONO_ACTIVO: 'cede_3_activo.png',
    UUID: 'BF3615D6-8C19-4A75-9D13-E933EF354574'
  },
  {
    NOMBRE: 'Isla de la Distracción Superficial',
    ICONO: 'cede_4.png',
    ICONO_ACTIVO: 'cede_4_activo.png',
    UUID: '70DD2BE0-FA71-4C17-AF17-7CBF651A8D44'
  },
  {
    NOMBRE: 'Isla de las Ideas Cambiantes',
    ICONO: 'cede_5.png',
    ICONO_ACTIVO: 'cede_5_activo.png',
    UUID: '048FFE47-16FD-4EC6-A44E-D41B15E02464'
  },
  {
    NOMBRE: 'Isla del Olvido Perpetuo',
    ICONO: 'cede_6.png',
    ICONO_ACTIVO: 'cede_6_activo.png',
    UUID: 'CE6BCBBF-1C08-451C-8CEB-77F96E139DDD'
  }
]



// WEBPACK FOOTER //
// ./src/providers/busqueda-tesoro/busqueda-tesoro-niveles.ts